/**
 * Which show style a picker shows selected (D32): the user's pick while it is
 * one of the choices, else the studio's default show style while it is one,
 * else the first — the lists may arrive after the dialog opened, and changing
 * the studio re-selects its default unless the user picked on purpose.
 */
export function shownShowStyle(picked: string, studioDefault: string | null, choices: readonly { readonly id: string }[]): string {
  if (choices.some((c) => c.id === picked)) return picked;
  if (studioDefault !== null && choices.some((c) => c.id === studioDefault)) return studioDefault;
  return choices[0]?.id ?? '';
}
